import { render, staticRenderFns } from "./MulticorderSUIM.vue?vue&type=template&id=c6d2d836&"
import script from "./MulticorderSUIM.vue?vue&type=script&lang=js&"
export * from "./MulticorderSUIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports